import makeSlice from '@web/slices/result/sliceMaker'

export default makeSlice().reducer
